var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgAdLogin = function SvgAdLogin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 88",
    style: {
      enableBackground: "new 0 0 58 88"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.adlogin{fill:#fff;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "adlogin",
    d: "M40.9,1.6v2.8C37.3,2.6,33.3,1.6,29,1.6c-14.8,0-26.8,12-26.8,26.9c0,14.9,12,26.9,26.8,26.9 c14.8,0,26.8-12,26.8-26.9V1.6H40.9z M29,16.7c6.5,0,11.8,5.3,11.8,11.8c0,6.5-5.3,11.8-11.8,11.8c-6.5,0-11.8-5.3-11.8-11.8 C17.2,22,22.5,16.7,29,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "adlogin",
    d: "M29,71.3c-6.5,0-11.8-5.3-11.8-11.9h-15c0,14.9,12,26.9,26.8,26.9c14.8,0,26.8-12.1,26.8-26.9h-15 C40.8,66,35.5,71.3,29,71.3"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adLogin.16473736.svg";
export { ForwardRef as ReactComponent };